export function ChartLoadingSkeleton() {
  return (
    <div className="relative flex h-full w-full flex-col justify-between">
      <div className="h-px w-full bg-foundations-subtlest" />
      <div className="h-px w-full bg-foundations-subtlest" />
      <div className="h-px w-full bg-foundations-subtlest" />
      <div className="h-px w-full bg-foundations-subtlest" />
      <div className="h-px w-full bg-foundations-subtlest" />

      <div className="absolute inset-x-0 bottom-0">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="103"
          viewBox="0 0 480 103"
          fill="none"
          preserveAspectRatio="none"
        >
          <path
            d="M43.7668 37.0055L0 48.9292V103H480V0L435.874 17.7911L392.825 28.4657L348.7 56.2198L305.65 70.0969L263.318 56.2198L218.117 50.5267H174.35L131.3 35.5822L87.5336 42.4802L43.7668 37.0055Z"
            className="fill-[theme(backgroundColor.foundations-subtlest)]"
          />
        </svg>
      </div>
    </div>
  );
}
